import { Component } from '@angular/core';

@Component({
  selector: 'app-cross-icon-svg',
  templateUrl: './cross-icon-svg.component.html',
  styleUrl: './cross-icon-svg.component.scss'
})
export class CrossIconSvgComponent {

}
